package views.representante

import androidx.compose.runtime.*
import getRelatorio
import kotlinx.browser.document
import kotlinx.dom.clear
import lbTitulo
import org.jetbrains.compose.web.attributes.onSubmit
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.renderComposable
import org.w3c.dom.HTMLDivElement
import utils.*
import views.componentes.ffCombo1Simples
import views.componentes.gsInput
import kotlin.js.Date

class rep005 {

    private val _t = "rep005"

    fun show() {

        lbTitulo!!.innerText = "005 - Oportunidades de venda"

        val htmlDiv1 = document.getElementById("htmlDiv1") as HTMLDivElement
        htmlDiv1.clear()

        renderComposable(rootElementId = "htmlDiv1") {
            body()
            //if (lemp5 != null && lemp5!!.count() > 0)
            //body1(lemp5!!)
        }
    }

    @Composable
    fun body() {
        Div(attrs = { classes("dlg-pad-top-5") }) {

            val _seOpcaoMes = remember { mutableStateOf(gsInput(_t)) }
            val _seOpcaoAno = remember { mutableStateOf(gsInput(_t)) }
            //val _seAno = remember { mutableStateOf(get) }
            _seOpcaoMes.value = Date().getMonth().ffZeroLeft(2)

            Div {
                Form(attrs = {
                    onSubmit { false }
                    style {
                        property("font-size", "small")
                    }
                }) {
                    Span(attrs = { style { fontWeight("bold") } }) { Text("Informações do relatório") }
                    Hr(attrs = { classes("dlg-hr") })
                    Span { Text("Período da emissão") }
                    Br()

                    Div({ classes("form-group", "input-group-append") }) {
                        ffCombo1Simples("Mês", ff.gs_mes, _seOpcaoMes, 40, "", true, {})
                        ffCombo1Simples("Ano", ff().verAno(3), _seOpcaoAno, 20, "", true, {})
                    }
                }


            }

            Div(attrs = { classes("form-group") }) {
                Button(attrs = {
                    classes("btn", "dlg-mobbt100"); onClick { _ ->

                    var sDtIni = "01/" + _seOpcaoMes.value + "/" + _seOpcaoAno.value
                    ff.println0("data " + sDtIni)
                    sDtIni = sDtIni.ffDsd().ffDdb()
                    getRelatorio(16, "|sDtIni${sDtIni}", false)
                }
                }
                ) {
                    Text("Visualizar")
                }
            }

        }

    }
}